import React from 'react';

const CircuitBackground: React.FC = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-0 opacity-20">
      <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <filter id="glow">
            <feGaussianBlur stdDeviation="2.5" result="blur" />
            <feComposite in="SourceGraphic" in2="blur" operator="over" />
          </filter>
        </defs>
        
        {/* Trace 1 */}
        <path 
          className="circuit-path" 
          d="M 100,0 L 100,200 L 300,200 L 300,400" 
          style={{ animationDelay: '0s' }}
        />
        <circle className="circuit-dot" cx="300" cy="400" r="3" />

        {/* Trace 2 */}
        <path 
          className="circuit-path" 
          d="M 1000,50 L 900,50 L 900,300 L 1100,300"
          style={{ stroke: 'var(--color-secondary)', animationDelay: '2s' }}
        />
        <circle className="circuit-dot" cx="1100" cy="300" r="3" style={{ fill: 'var(--color-secondary)' }} />

        {/* Trace 3 */}
        <path 
          className="circuit-path" 
          d="M 0,600 L 200,600 L 200,800 L 400,800"
          style={{ stroke: 'var(--color-accent)', animationDelay: '4s' }}
        />
        <circle className="circuit-dot" cx="400" cy="800" r="3" style={{ fill: 'var(--color-accent)' }} />

        {/* Trace 4 */}
        <path 
          className="circuit-path" 
          d="M 1200,700 L 1000,700 L 1000,900 L 800,900"
          style={{ animationDelay: '6s' }}
        />
        <circle className="circuit-dot" cx="800" cy="900" r="3" />

        {/* More decorative lines */}
        <line x1="10%" y1="0" x2="10%" y2="100%" stroke="var(--color-primary)" strokeWidth="0.5" opacity="0.1" />
        <line x1="90%" y1="0" x2="90%" y2="100%" stroke="var(--color-secondary)" strokeWidth="0.5" opacity="0.1" />
      </svg>
    </div>
  );
};

export default CircuitBackground;
